import apiHelper from '@/utils/apiHelper';

const getHistoryUser = async (id: string) => {
  try {
    const response = await apiHelper(
      'GET',
      `/user-history/user/${id}`,
      undefined,
      { useGateway: true },
    );
    if (!response) {
      throw new Error('No response from API');
    }
    return response.data;
  } catch (err: unknown) {
    const message = err instanceof Error ? err.message : String(err);
    if (!message.match(/(404)/)) {
      const error = new Error(`Error getting history user: ${message}`);
      (error as Error & { cause: unknown }).cause = err;
      throw error;
    }
    return {};
  }
};

export default getHistoryUser;
